var Backbone = require('backbone');
var _ = require('underscore');

require('./TopNav.less');

module.exports = Backbone.View.extend({

    el: '.TopNav',


    events: {
        'click .TopNav-link--current': 'onCurrentClick',
        'click .TopNav-link--map': 'onMapClick'
    },


    initialize: function () {
        //на девайсах надо зафиксировать хедер
        app.vent.on('gallery-popup-show', function (pos) {
            this.$el.addClass('TopNav--gallery-popup-visible');
        }.bind(this));

        app.router.on('route', function () {
            var url = window.location.pathname;
            if (app.data.lang == 'en') {
                url = '/' + url.split('/')
                        .slice(2)
                        .join('/');
            }
            this.$('.TopNav-link--lang[data-lang=ru]').attr('href', url);
            this.$('.TopNav-link--lang[data-lang=en]').attr('href', '/en' + url);
        }.bind(this));

        app.vent.on('gallery-popup-hide', function (pos) {
            this.$el.removeClass('TopNav--gallery-popup-visible');
        }.bind(this));
    },


    onCurrentClick: function () {

        //на телефоне надо закрыть попап галереи если он открыт
        //т.е. просто убеждаемся что мы по правильному урлу
        Backbone.history.navigate('/' + (window.app.data.lang == 'en' ? 'en/' : ''), {trigger: 'true'});

        //надло дать время на триггер смены урла чтобы главная появилась
        setTimeout(function () {
            app.vent.trigger('scrollto', 'current');
        }, 100);
    },


    onMapClick: function () {

        //на телефоне надо закрыть попап галереи если он открыт
        //т.е. просто убеждаемся что мы по правильному урлу
        Backbone.history.navigate('/', {trigger: 'true'});

        //надло дать время на триггер смены урла чтобы главная появилась
        setTimeout(function () {
            app.vent.trigger('scrollto', 'map');
        }, 100);
    }

});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/TopNav/TopNav.js
// module id = 20
// module chunks = 0